/* COLD BOYS — glitch pe logo-uri (CLD8, COLD ENT., CLD ARB).
   <img class="js-cld8-glitch" data-glitch="low|mid|high"> -> SVG inline animat.
   Logo-urile cu litere separate: literele se inlocuiesc cu gotice / kanji / simboluri / blocuri.
   Logo-urile dintr-o singura forma (CLD ARB): felii decalate + glife suprapuse. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var imgs = document.querySelectorAll('img.js-cld8-glitch');
  if (!imgs.length) return;

  var f = document.createElement('link');
  f.rel = 'stylesheet';
  f.href = 'https://fonts.googleapis.com/css2?family=UnifrakturMaguntia&text=CDLBYSOENTcdlbysoent8&display=swap';
  document.head.appendChild(f);

  var NS = 'http://www.w3.org/2000/svg';
  // litera fiecarui <path>, in ordinea din fisier
  var META = {
    'CLD8':     { chars: ['Y', 'S', 'B', 'D', 'L', 'C', '8'] },
    'COLD_ENT': { chars: ['C', 'D', 'L', 'S', 'Y', 'B', 'O', 'O', 'N', 'E', 'T', '.'] }
  };
  var KANJI = '冷寒氷闇魂空凶霊狂鬼呪'.split('');
  var SYM = ['⚙', '⊗', '⌖', 'Φ', '╳', 'ᚱ', 'ᚠ', '✕', '※', '⟁', '∴', '⌁'];
  var EIGHT = ['∞', '❽', '⑧', '魂', '8'];
  var FONT = {
    frak: "'UnifrakturMaguntia', serif",
    cjk: "'Hiragino Sans','Noto Sans JP','Yu Gothic','PingFang SC',sans-serif",
    sym: "'Apple Symbols','Segoe UI Symbol','Noto Sans Symbols 2',sans-serif"
  };
  var PROFILE = {
    low:  { tick: 70, p: 0.40, max: 2, burstEvery: [1200, 2600], burstLen: 900 },
    mid:  { tick: 65, p: 0.30, max: 3, burstEvery: [600, 1600],  burstLen: 1300 },
    high: { tick: 60, p: 0.22, max: 3, burstEvery: null }
  };
  function rnd(a) { return a[Math.floor(Math.random() * a.length)]; }
  function rint(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
  function keyOf(src) { var m = /\/(CLD8|COLD_ENT|CLD_ARB)(_white)?\.svg/i.exec(src || ''); return m ? m[1].toUpperCase() : ''; }

  var cache = {};
  function getSvg(src) { var k = src.split('?')[0]; return cache[k] || (cache[k] = fetch(src).then(function (r) { return r.text(); })); }

  var uid = 0;
  function build(img, text) {
    var holder = document.createElement('div');
    holder.innerHTML = text;
    var svg = holder.querySelector('svg');
    if (!svg) return;
    var id = 'cbg' + (uid++);
    var fill = svg.getAttribute('fill') || '#f0ede8';
    svg.removeAttribute('id');
    svg.setAttribute('class', (img.getAttribute('class') || '').replace('js-cld8-glitch', '').trim() + ' cld8-glitch');
    if (img.getAttribute('style')) svg.setAttribute('style', img.getAttribute('style'));
    if (img.getAttribute('width')) svg.setAttribute('width', img.getAttribute('width'));   // ca la <img>; CSS-ul are prioritate
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', img.alt || 'COLD BOYS');
    svg.style.overflow = 'visible';
    var defs = document.createElementNS(NS, 'defs');
    defs.innerHTML = '<pattern id="' + id + 'd" width="4" height="4" patternUnits="userSpaceOnUse">' +
      '<rect width="2" height="2" fill="' + fill + '"/><rect x="2" y="2" width="2" height="2" fill="' + fill + '"/></pattern>';
    svg.insertBefore(defs, svg.firstChild);
    img.parentNode.replaceChild(svg, img);
    var meta = META[keyOf(img.currentSrc || img.src)] || { chars: [] };
    var P = PROFILE[img.dataset.glitch] || PROFILE.mid;
    var ready = false, slots = [];

    function init() {             // bbox-urile se calculeaza cand logo-ul e vizibil
      if (ready) return true;
      var vb = svg.viewBox.baseVal, paths = svg.querySelectorAll('path');
      for (var i = 0; i < paths.length; i++) {
        var b; try { b = paths[i].getBBox(); } catch (e) { return false; }
        if (!b.width) return false;
        var big = b.width > vb.width * 0.5;
        if (!big && b.width < vb.width * 0.03) continue;   // puncte mici
        var t = document.createElementNS(NS, 'text');
        t.setAttribute('text-anchor', 'middle'); t.setAttribute('dominant-baseline', 'central');
        t.setAttribute('fill', fill); t.style.display = 'none';
        var r = document.createElementNS(NS, 'rect');
        r.setAttribute('fill', 'url(#' + id + 'd)'); r.style.display = 'none';
        svg.appendChild(t); svg.appendChild(r);
        var s = { path: paths[i], text: t, rect: r, left: 0,
          box: { x: b.x, y: b.y, w: b.width, h: b.height, ch: meta.chars[i] || '', tall: b.height > vb.height * 0.8 && !big, big: big } };
        if (big) {                 // felii pentru forma mare
          paths[i].id = paths[i].id || (id + 'p' + i);
          s.slices = [];
          for (var k = 0; k < 3; k++) {
            var cp = document.createElementNS(NS, 'clipPath'); cp.id = id + 'c' + i + k;
            var cr = document.createElementNS(NS, 'rect'); cp.appendChild(cr); defs.appendChild(cp);
            var u = document.createElementNS(NS, 'use');
            u.setAttribute('href', '#' + paths[i].id); u.setAttribute('clip-path', 'url(#' + cp.id + ')');
            u.style.display = 'none'; svg.appendChild(u);
            s.slices.push({ use: u, rect: cr });
          }
        }
        slots.push(s);
      }
      ready = slots.length > 0;
      return ready;
    }

    function glitch(s) {
      var b = s.box, t = s.text, r = s.rect, kind = Math.random();
      restore(s);
      if (b.big) {                 // forma mare: 1-3 felii decalate + uneori o glifa
        s.path.style.opacity = Math.random() < 0.5 ? '0.25' : '1';
        s.slices.forEach(function (sl) {
          if (Math.random() < 0.3) return;
          var h = b.h * (0.06 + Math.random() * 0.22), y = b.y + Math.random() * (b.h - h);
          sl.rect.setAttribute('x', b.x - 40); sl.rect.setAttribute('width', b.w + 80);
          sl.rect.setAttribute('y', y); sl.rect.setAttribute('height', h);
          sl.use.setAttribute('transform', 'translate(' + rint(-18, 18) + ',0)');
          sl.use.style.display = '';
        });
        if (Math.random() < 0.35) {
          var gs = b.h * (0.3 + Math.random() * 0.25);
          t.setAttribute('x', b.x + b.w * (0.15 + Math.random() * 0.7)); t.setAttribute('y', b.y + b.h * (0.3 + Math.random() * 0.4));
          t.textContent = Math.random() < 0.6 ? rnd(KANJI) : rnd(SYM);
          t.setAttribute('font-family', FONT.cjk); t.setAttribute('font-size', gs.toFixed(1));
          t.style.display = '';
        }
        return;
      }
      s.path.style.opacity = '0';
      t.removeAttribute('transform');
      t.setAttribute('x', b.x + b.w / 2); t.setAttribute('y', b.y + b.h / 2);
      if (kind < 0.12) return;                                   // gol
      if (kind < 0.22) {                                         // bloc dither
        var w = b.w * (0.5 + Math.random() * 0.5), h = Math.min(b.h, b.w) * (0.5 + Math.random() * 0.5);
        r.setAttribute('x', b.x + (b.w - w) / 2); r.setAttribute('y', b.y + (b.h - h) / 2);
        r.setAttribute('width', w); r.setAttribute('height', h); r.style.display = '';
        return;
      }
      if (kind < 0.30) {                                         // fantoma decalata
        s.path.style.opacity = '0.35';
        s.path.style.transform = 'translate(' + rint(-4, 4) + 'px,0)';
        return;
      }
      var ch, font, size = b.h * 1.02;
      if (b.tall) {
        ch = rnd(EIGHT);
        font = ch === '8' ? FONT.frak : (ch === '魂' ? FONT.cjk : FONT.sym);
        size = b.h * (ch === '∞' ? 0.62 : 0.78);
        if (ch === '∞') t.setAttribute('transform', 'rotate(90 ' + (b.x + b.w / 2) + ' ' + (b.y + b.h / 2) + ')');
      } else if (kind < 0.58 && b.ch && b.ch !== '.') { ch = b.ch; font = FONT.frak; size *= 1.08; }
      else if (kind < 0.80) { ch = rnd(KANJI); font = FONT.cjk; size *= 0.82; }
      else { ch = rnd(SYM); font = FONT.sym; size *= 0.8; }
      t.textContent = ch; t.setAttribute('font-family', font); t.setAttribute('font-size', size.toFixed(1));
      t.style.display = '';
    }
    function restore(s) {
      s.path.style.opacity = ''; s.path.style.transform = '';
      s.text.style.display = 'none'; s.rect.style.display = 'none';
      if (s.slices) s.slices.forEach(function (sl) { sl.use.style.display = 'none'; });
    }

    var visible = false, timer = null, burstUntil = P.burstEvery ? 0 : Infinity, nextBurst = 0;
    function step() {
      if (!init()) return;
      var now = Date.now();
      if (P.burstEvery && now >= nextBurst) { burstUntil = now + P.burstLen; nextBurst = now + rint(P.burstEvery[0], P.burstEvery[1]); }
      var active = 0;
      slots.forEach(function (s) {
        if (s.left > 0) {
          s.left--;
          if (s.left === 0) restore(s); else { if (Math.random() < 0.35) glitch(s); active++; }
        }
      });
      if (now < burstUntil && active < P.max && Math.random() < P.p) {
        var free = slots.filter(function (s) { return s.left === 0; });
        if (free.length) { var s = rnd(free); s.left = rint(1, 4); glitch(s); }
      }
    }
    function start() { if (!timer && visible && !document.hidden) timer = setInterval(step, P.tick); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } slots.forEach(function (s) { s.left = 0; restore(s); }); }
    // Safari nu declanseaza sigur IntersectionObserver pe <svg> inline -> observam parintele + fallback
    var target = svg.parentNode && svg.parentNode.nodeType === 1 ? svg.parentNode : svg, seen = false;
    new IntersectionObserver(function (e) { seen = true; visible = e[0].isIntersecting; visible ? start() : stop(); }).observe(target);
    setTimeout(function () {
      if (seen) return;
      var r = svg.getBoundingClientRect();
      visible = r.bottom > 0 && r.top < (window.innerHeight || 800);
      if (visible) start();
    }, 1200);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  }

  Array.prototype.forEach.call(imgs, function (img) {
    var src = img.currentSrc || img.src;
    getSvg(src).then(function (text) { build(img, text); }).catch(function () {});
  });
})();
